module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar",
    class: {
      navbarPopup: !_vm.closePage && _vm.closePopup
    }
  }, [_c('div', {
    staticClass: "navbar-inner no-swipeback",
    class: {
      'navbar-inner-popup': !_vm.closePage && _vm.closePopup
    },
    on: {
      "click": _vm.closeCountryPickerModal
    }
  }, [_c('f7-nav-left', [(_vm.isSmallScreen) ? _c('f7-link', {
    style: ({
      color: _vm.grey
    }),
    attrs: {
      "icon-fa": "bars",
      "color": "#000000",
      "close-picker": "",
      "open-panel": "left"
    },
    on: {
      "click": _vm.updateNotifications
    }
  }) : _c('f7-link', {
    staticStyle: {
      "color": "#ffffff",
      "width": "79px"
    },
    attrs: {
      "icon-fa": "bars"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "showSmallScreenOnly titleApp centrageLogoSmallScreen"
  }, [_c('p', {
    class: {
      'streammind-icon-popup': _vm.closePopup
    },
    on: {
      "click": function($event) {
        return _vm.redirectionPage(_vm.service)
      }
    }
  }, [_c('f7-icon', {
    staticClass: "streammind-icon",
    class: _vm.getColor
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "showLargeScreenOnly"
  }, [(_vm.picker && !_vm.closePopup && _vm.service.length > 4) ? _c('p', {
    staticClass: "titleApp centrageLogoLargeScreen",
    on: {
      "click": function($event) {
        return _vm.redirectionPage(_vm.service)
      }
    }
  }, [_c('f7-icon', {
    staticClass: "streammind-icon",
    class: _vm.getColor
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.closePage && _vm.closePopup) ? _c('p', {
    staticClass: "titleApp"
  }, [_c('f7-icon', {
    staticClass: "streammind-icon streammind-icon-popup",
    class: _vm.getColor
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.closePopup && !_vm.closePage) ? _c('div', {
    staticClass: "cancelButton"
  }, [_c('f7-link', {
    staticClass: "streammindContactListButton orangeFont",
    attrs: {
      "close-popup": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.cncl')))])], 1) : (_vm.closePage && !_vm.returnPreviousPage) ? _c('div', [_c('f7-link', {
    staticClass: "streammindContactListButton cancelButton orangeFont",
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.cncl')))])], 1) : (_vm.returnPreviousPage) ? _c('div', [_c('f7-link', {
    staticClass: "streammindContactListButton cancelButton orangeFont",
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.rtrn')))])], 1) : _c('div', [_c('div', {
    staticStyle: {
      "min-width": "44px"
    }
  })]), _vm._v(" "), (_vm.userIsGuest()) ? _c('f7-nav-right', [(_vm.picker && !_vm.closePopup && !_vm.closePage && !_vm.returnPreviousPage) ? _c('f7-link', {
    style: ({
      color: 'silver',
      backgroundColor: 'white'
    }),
    attrs: {
      "no-link-class": "",
      "icon-fa": "th"
    }
  }) : _vm._e()], 1) : _c('f7-nav-right', [(_vm.picker && !_vm.closePopup && !_vm.closePage && !_vm.returnPreviousPage && _vm.$engine.user.validateAccess('serviceSwitcher')) ? _c('f7-link', {
    style: ({
      color: _vm.grey
    }),
    attrs: {
      "close-picker": "",
      "icon-fa": "th",
      "open-popup": "",
      "data-popup": "#service-switcher-true"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.subNavTitle !== '' && !_vm.closePage && _vm.closePopup) ? _c('f7-subnavbar', {
    staticClass: "subtitle subtitlePopup subnavbarPopup",
    style: ('border-bottom-color : ' + _vm.color)
  }, [(!_vm.closePage && _vm.closePopup) ? _c('div', {
    staticClass: "subNavtitlePopup"
  }, [_vm._v(_vm._s(_vm.subNavTitle))]) : _vm._e()]) : (_vm.subNavTitle !== '') ? _c('f7-subnavbar', {
    staticClass: "subtitle",
    style: ('border-bottom-color : ' + _vm.color)
  }, [_c('div', {
    staticClass: "returnButtonMarginLeft"
  }, [(_vm.ReturnButton) ? _c('f7-link', {
    style: ({
      color: _vm.grey
    }),
    attrs: {
      "close-picker": ""
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_c('f7-icon', {
    staticStyle: {
      "transform": "rotate(180deg)"
    },
    attrs: {
      "f7": "play_fill"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "subNavtitle"
  }, [_vm._v(_vm._s(_vm.subNavTitle))]), _vm._v(" "), (_vm.popoverName) ? _c('div', {
    staticClass: "popoverNamePaddingRight"
  }) : _c('div', [_c('div', {
    staticStyle: {
      "margin-left": "15px"
    }
  })])]) : _vm._e()], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-13a119f2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13a119f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/pageNavBar.vue
// module id = 1626
// module chunks = 2